import { c as _c } from "react/compiler-runtime";
import type { PlayInfo } from '@module/apis/client-side/live/type';
import useChatRoomLifecycle from '@module/helpers/chat/useChatRoomLifecycle';
import useChatScrollController from '@module/helpers/chat/useChatScrollController';
import useRtLowLatencySwitchGuide from '@module/helpers/chat/useRtLowLatencySwitchGuide';
import useSilverModeAdultChatGuide from '@module/helpers/chat/useSilverModeAdultChatGuide';
import type { TabList } from '@module/types/broadcast-setting/type';
import type { Dispatch, SetStateAction } from 'react';
import ChatEventLottie from '../_components/ChatEventLottie';
import FirstSponEffect from '../_components/FirstSponEffect';
import SponSummary from '../_components/SponSummary';
import VipFanListBox from '../_components/VipFanListBox';
import ChatComposer from './_components/ChatComposer';
import ChatMessageList from './_components/ChatMessageList';
interface Props {
  isRoomMaster: boolean;
  isManager: boolean;
  playInfo: PlayInfo;
  setStepType: Dispatch<SetStateAction<TabList>>;
  chatInputValue: string;
  setChatInputValue: Dispatch<SetStateAction<string>>;
}

/**
 * 채팅 영역의 합성 루트 + 레이아웃. 읽기(ChatMessageList)와 쓰기(ChatComposer)를 조립하고,
 * 둘이 공유하는 스크롤 상태(useChatScrollController)만 여기서 소유해 내려준다.
 */
function ChatContainer(t0) {
  const $ = _c(29);
  const {
    playInfo,
    isRoomMaster,
    isManager,
    setStepType,
    chatInputValue,
    setChatInputValue
  } = t0;
  const {
    scrollRef,
    isNearBottom
  } = useChatScrollController();
  useChatRoomLifecycle();
  useSilverModeAdultChatGuide();
  useRtLowLatencySwitchGuide();
  const isFirstSponEffectVisible = isRoomMaster;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ChatEventLottie />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isFirstSponEffectVisible) {
    t2 = isFirstSponEffectVisible && <FirstSponEffect />;
    $[1] = isFirstSponEffectVisible;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== playInfo || $[4] !== setStepType) {
    t3 = <VipFanListBox playInfo={playInfo} setStepType={setStepType} />;
    $[3] = playInfo;
    $[4] = setStepType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isManager || $[7] !== isRoomMaster) {
    t4 = (isRoomMaster || isManager) && <SponSummary />;
    $[6] = isManager;
    $[7] = isRoomMaster;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isManager || $[10] !== isRoomMaster || $[11] !== playInfo || $[12] !== scrollRef) {
    t5 = <ChatMessageList playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} scrollRef={scrollRef} />;
    $[9] = isManager;
    $[10] = isRoomMaster;
    $[11] = playInfo;
    $[12] = scrollRef;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== chatInputValue || $[15] !== isNearBottom || $[16] !== isRoomMaster || $[17] !== playInfo || $[18] !== scrollRef || $[19] !== setChatInputValue) {
    t6 = <ChatComposer playInfo={playInfo} isRoomMaster={isRoomMaster} chatInputValue={chatInputValue} setChatInputValue={setChatInputValue} scrollRef={scrollRef} isNearBottom={isNearBottom} />;
    $[14] = chatInputValue;
    $[15] = isNearBottom;
    $[16] = isRoomMaster;
    $[17] = playInfo;
    $[18] = scrollRef;
    $[19] = setChatInputValue;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
    t7 = <div className="flex h-full w-full flex-col">{t3}{t4}{t5}{t6}</div>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t2 || $[27] !== t7) {
    t8 = <section className="relative h-full w-full flex-1 flex-col">{t1}{t2}{t7}</section>;
    $[26] = t2;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
}
export default ChatContainer;